var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveDownDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 15112",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 956",
    d: "M11.667 20.021a.789.789 0 01-.237-.177l-3.884-4.251a.862.862 0 01.022-1.169.756.756 0 01.546-.231.765.765 0 01.568.253l2.531 2.769V4.729a.789.789 0 111.577 0v12.486l2.523-2.766a.771.771 0 011.122-.021.865.865 0 01.019 1.169l-3.868 4.232a.774.774 0 01-.587.272.75.75 0 01-.332-.08zM7.62 15.527l3.885 4.249a.643.643 0 00.2.154.66.66 0 00.29.069.678.678 0 00.513-.24l3.868-4.232a.752.752 0 00.193-.52.752.752 0 01-.193.52l-3.868 4.232a.678.678 0 01-.513.24.66.66 0 01-.29-.069.643.643 0 01-.2-.154L7.62 15.527a.752.752 0 01-.193-.52.752.752 0 00.193.522zm5.07 1.941zm2.7-2.953a.67.67 0 01.976-.02.668.668 0 00-.976.02zm-6.777 0a.665.665 0 00-.973-.02.667.667 0 01.973.02z"
  })));
}
export default SvgMoveDownDesktop;